module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2f43780e10aa78eff9f.worker.js");
};